import { useSelector } from "react-redux";
import DashboardMain from "../DashboardMain";
import DashboardIcon from "../../assets/Icons/Dashboard.svg";
import Settings from "../settings/Settings";
import MenuManagement from "../menu_management/MenuManagement";
import BuySMS from "../buysms/BuySMS";
import Vendor from "../vendor/Vendor";
import UserMaster from "../users/UserMaster";
import Retailer from "../Retailer/Retailer";
import CustomerMaster from "../customer/CustomerMaster";
import SellSMS from "../sellsms/SellSMS";
import CustomerIcon from "../../assets/Icons/Customer Master.svg";
import UsersIcon from "../../assets/Icons/usericon.svg";
import BulkSmsIcon from "../../assets/Icons/bulk message icon.svg";
import WalletBlueIcon from "../../assets/Icons/Walletwhite_icon.svg";
import RetailerIcon from "../../assets/Icons/RetailerIcon.svg";
import VendorMasterIcon from "../../assets/Icons/Vendor Master.svg";
import SellSMSIcon from "../../assets/Icons/Sell SMS (1).svg";
import TxnReport from "../../assets/Icons/report_icon_01.svg";
import OrderMasterIcon from "../../assets/Icons/Order_master_white.svg";
import RechargeIcon from "../../assets/Icons/report_icon_03.svg";
import BuySMSIcon from "../../assets/Icons/BuySMSIcon.svg";
import SettingsIcon from "../../assets/Icons/SettingsIcon.svg";
import MenuManagementIcon from "../../assets/Icons/MenuManagementIcon.svg";
import APIDocIcon from "../../assets/Icons/api document.svg";
import SmsHistoryIcon from "../../assets/Icons/sms hisotry (5).svg";
import VendorHistoryIcon from "../../assets/Icons/Vendor History.svg";
import RoleMasterIcon from "../../assets/Icons/role master.svg";
import TopUpReqIcon from "../../assets/Icons/Topup request.svg";
import SmsHistory from "../smshistory/SmsHistory";
import SMSMasterIcon from "../../assets/Icons/sms master.svg";
import CourierMasterIcon from "../../assets/Icons/Courier_add_icon.svg";
import LedgerIcon from "../../assets/Icons/Ledger_icon.svg";
import APIDoc from "../apidocument/APIDoc";
import SMSMaster from "../smsmaster/SMSMaster";
import DLT from "../dlt/DLT";
import RoleMaster from "../role/RoleMaster";
import TopUpReq from "../topuprequest/TopUpReq";
import VendorTxnHistory from "../vendorhistory/VendorTxtHistory";
import BulkReport from "../bulkReport/BulkReport";
import MainWalletActivity from "../mainwalletactivity/WalletActivity";
import TopUpMainWalletReq from "../topupmainwalletrequest/TopUpMainWalletReq";
import RcsHistory from "../rcshistory/RcsHistory";
import TransactionReport from "../transactionReport/TransactionReport";
import Recharge from "../recharge/Recharge";
import CourierMaster from "../courier/CourierMaster";
import OrderMaster from "../order/OrderMaster";
import Ledger from "../ledger/Ledger";
import RCSStandalone from "../rcsstandalonemsg/RCSStandalone";
import RCSCarousel from "../rcscarousel/RCSCarouseltabs";
import RCSSPainText from "../rcsplaintext/RCSPlainText";
import RCSPlainTextIcon from "../../assets/Icons/rcs_plain_text.svg";
import RCSStandAloneIcon from "../../assets/Icons/rcs_standalone01.svg";
import RCSCarouselIcon from "../../assets/Icons/rcs_carousel02.svg";
import CustomerEnquiries from "../CustomerEnquiries/CustomerEnquiries";
import PickupAddress from "../pickupaddress/PickupAddress";
import TopUPReqModal from "../topuprequest/TopUPReqModal";
import TopUpRCSModal from "../topuprequest/TopUpRCSModal";
import AIDashboard from "../ai-dashboard/AIDashboard";
import WhatsappTemplate from "../WhatsappTemplate/WhatsappTemplate";
import RcsTemplate from "../RcsTemplate/RcsTemplate";

const Routes = () => {
  const { loading, error, isAuthenticated, user, menu, userRole } = useSelector(
    (state) => state.auth,
  );
  console.log("menu", menu);
  // const [array, setArray] = useState("")
  // useEffect(async() => {
  //   const Menu = sessionStorage.getItem("menu");
  //   const array1 = await Menu;
  //   // console.log("array1",array1);
  //   // const array1 = "111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111"
  //   // console.log("array2",array2);
  //   const array =
  //     Menu !== null &&
  //     Menu !== undefined &&
  //     Menu != "" &&
  //     array1?.split("").map((char) => parseInt(char));
  //   setArray(array)
  // }, [])

  // const Menu = sessionStorage.getItem("menu");
  const array1 = menu;
  // console.log("array1",array1);
  // const array1 = "111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111"
  // console.log("array2",array2);

  const array =
    menu !== null &&
    menu !== undefined &&
    menu != "" &&
    array1?.split("").map((char) => parseInt(char));

  const PROTECTED_ROUTES = [
    {
      name: "Home",
      id: "dashboard",
      url: array[0] == "1" ? "/dashboard" : null,
      component: <DashboardMain />,
      arr: array[0],
      roles: [],
      Icon: DashboardIcon,
    },
    {
      name: "AI Dashboard",
      id: "AI dashboard",
      url: array[87] == "1" ? "/aiDashboard" : null,
      component: <AIDashboard />,
      arr: array[87],
      roles: [],
      Icon: DashboardIcon,
    },
    // User Controller
    {
      name: "User Master",
      id: "userMaster",
      url: array[1] == "1" ? "/userMaster" : null,
      component: <UserMaster />,
      arr: array[1],
      roles: [],
      Icon: UsersIcon,
    },
    {
      name: "User Master",
      id: "userMaster",
      url: array[1] == "1" ? "/userMaster" : null,
      roles: [],
      Icon: UsersIcon,
      menuShow: true,
      grandChild: [
        { arr: array[2] },
        { arr: array[3] },
        { arr: array[4] },
        { arr: array[5] },
        { arr: array[54] },
        null,
        null,
        { arr: array[82] },
      ],
    },
    {
      name: "Create User",
      id: "create",
      url: array[2] == "1" ? "/create" : null,
      roles: [],
      component: <UserMaster />,
      Icon: UsersIcon,
    },
    {
      name: "Edit User",
      id: "edit",
      url: array[3] == "1" ? "/edit" : null,
      roles: [],
      component: <UserMaster />,
      Icon: UsersIcon,
    },
    {
      name: "Suspend User",
      id: "delete",
      url: array[4] == "1" ? "/delete" : null,
      roles: [],
      component: <UserMaster />,
      Icon: UsersIcon,
    },
    {
      name: "Authorize User",
      id: "auth",
      url: array[5] == "1" ? "/auth" : null,
      roles: [],
      component: <UserMaster />,
      Icon: UsersIcon,
    },
    {
      name: "Audit Trial",
      id: "audittrl",
      url: array[54] == "1" ? "/audittrl" : null,
      roles: [],
      component: <UserMaster />,
      Icon: CustomerIcon,
    },
    // Vendor Controller
    {
      name: "Vendor Master",
      id: "vendorMaster",
      url: array[6] == "1" ? "/vendorMaster" : null,
      component: <Vendor />,
      arr: array[6],
      roles: [],
      Icon: VendorMasterIcon,
    },
    {
      name: "Vendor Master",
      id: "vendorMaster",
      url: array[6] == "1" ? "/vendorMaster" : null,
      roles: [],
      Icon: VendorMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[7] },
        { arr: array[8] },
        { arr: array[9] },
        { arr: array[10] },
        { arr: array[55] },
      ],
    },
    {
      name: "Create Vendor",
      id: "create",
      url: array[7] == "1" ? "/create" : null,
      roles: [],
      component: <Vendor />,
      Icon: VendorMasterIcon,
    },
    {
      name: "Edit Vendor",
      id: "edit",
      url: array[8] == "1" ? "/edit" : null,
      roles: [],
      component: <Vendor />,
      Icon: VendorMasterIcon,
    },
    {
      name: "Suspend Vendor",
      id: "delete",
      url: array[9] == "1" ? "/delete" : null,
      roles: [],
      component: <Vendor />,
      Icon: VendorMasterIcon,
    },
    {
      name: "Authorize Vendor",
      id: "auth",
      url: array[10] == "1" ? "/auth" : null,
      roles: [],
      component: <Vendor />,
      Icon: VendorMasterIcon,
    },
    {
      name: "Audit Trial",
      id: "audittrl",
      url: array[55] == "1" ? "/audittrl" : null,
      roles: [],
      component: <Vendor />,
      Icon: CustomerIcon,
    },

    {
      name: "Customer Enquiries",
      id: "customerEnquiries",
      url: array[75] == "1" ? "/customerEnquiries" : null,
      component: <CustomerEnquiries />,
      arr: array[75],
      roles: [],
      Icon: CustomerIcon,
    },

    // Customer Controller
    {
      name: "Company Master",
      id: "CustomerOnboarding",
      url: array[11] == "1" ? "/CustomerOnboarding" : null,
      component: <CustomerMaster />,
      arr: array[11],
      roles: [],
      Icon: CustomerIcon,
    },
    {
      name: "Customer Onboarding",
      id: "CustomerOnboarding",
      url: array[11] == "1" ? "/CustomerOnboarding" : null,
      roles: [],
      Icon: CustomerIcon,
      grandChild: [
        { arr: array[12] },
        { arr: array[13] },
        { arr: array[14] },
        { arr: array[15] },
        { arr: array[56] },
        { arr: array[16] },
      ],
    },
    // Customer Controller
    {
      name: "Retailer (Courier)",
      id: "courierCompanyOnboarding",
      url: array[61] == "1" ? "/courierCompanyOnboarding" : null,
      component: <CourierMaster />,
      arr: array[61],
      roles: [],
      Icon: CourierMasterIcon,
    },
    {
      name: "Retailer (Courier)",
      id: "courierCompanyOnboarding",
      url: array[61] == "1" ? "/courierCompanyOnboarding" : null,
      roles: [],
      Icon: CourierMasterIcon,
      grandChild: [
        { arr: array[62] },
        { arr: array[63] },
        { arr: array[64] },
        { arr: array[65] },
        null,
        null,
        { arr: array[75] },
      ],
    },
    // Pickup Address
    {
      name: "Pickup Address",
      id: "pickuporder",
      url: array[77] == "1" ? "/pickuporder" : null,
      component: <PickupAddress />,
      arr: array[77],
      roles: [],
      Icon: CourierMasterIcon,
    },
    {
      name: "Pickup Address",
      id: "pickuporder",
      url: array[77] == "1" ? "/pickuporder" : null,
      roles: [],
      Icon: CourierMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[78] }, // Create
        { arr: array[79] }, // Fetch
        { arr: array[80] }, // Modify
        { arr: array[81] }, // View
      ],
    },
    {
      name: "Create Pickup Address",
      id: "create",
      url: array[78] == "1" ? "/pickuporder/create" : null,
      roles: [],
      component: <PickupAddress />,
      Icon: CourierMasterIcon,
    },
    {
      name: "Fetch Pickup Address",
      id: "fetch",
      url: array[79] == "1" ? "/pickuporder/fetch" : null,
      roles: [],
      component: <PickupAddress />,
      Icon: CourierMasterIcon,
    },
    {
      name: "Modify Pickup Address",
      id: "modify",
      url: array[80] == "1" ? "/pickuporder/modify" : null,
      roles: [],
      component: <PickupAddress />,
      Icon: CourierMasterIcon,
    },
    {
      name: "View Pickup Address",
      id: "view",
      url: array[81] == "1" ? "/pickuporder/view" : null,
      roles: [],
      component: <PickupAddress />,
      Icon: CourierMasterIcon,
    },
    //Order Master
    {
      name: "Order Master",
      id: "orderMaster",
      url: array[66] == "1" ? "/orderMaster" : null,
      component: <OrderMaster />,
      arr: array[66],
      roles: [],
      Icon: OrderMasterIcon,
    },
    {
      name: "Create Customer",
      id: "create",
      url: array[12] == "1" ? "/create" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "Edit Customer",
      id: "edit",
      url: array[13] == "1" ? "/edit" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "Suspend Customer",
      id: "delete",
      url: array[14] == "1" ? "/delete" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "Authorize Customer",
      id: "auth",
      url: array[15] == "1" ? "/auth" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "DLT",
      id: "dlt",
      url: array[16] == "1" ? "/dlt" : null,
      roles: [],
      component: <DLT />,
      Icon: CustomerIcon,
    },
    {
      name: "Audit Trial",
      id: "audittrl",
      url: array[56] == "1" ? "/audittrl" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    //  {
    //     name: "Entity Id",
    //     id: "entityId",
    //     url: array[17] == "1" ,
    //     roles: [],
    //     component: <DLT />,
    //     Icon: CustomerIcon,
    //   },
    //   {
    //     name: "Sender Id",
    //     id: "sendorId",
    //     url: array[18] == "1" ,
    //     roles: [],
    //     component: <DLT />,
    //     Icon: CustomerIcon,
    //   },
    //   {
    //     name: "Template",
    //     id: "template",
    //     url: array[19] == "1" ,
    //     roles: [],
    //     component: <DLT />,
    //     Icon: CustomerIcon,
    //   },
    // Retailer Controller
    // {
    //   name: "Retailer Master",
    //   id: "retailerMaster",
    //   url: array[17] == "1" ? "/retailerMaster" : null,
    //   component: <Retailer />,
    //   arr: array[17],
    //   routes: [],
    //   Icon: RetailerIcon,
    // },
    // {
    //   name: "Retailer Master",
    //   id: "retailerMaster",
    //   url: array[17] == "1" ? "/retailerMaster" : null,
    //   roles: [],
    //   Icon: RetailerIcon,
    //   menuShow: true,
    //   grandChild: [
    //     { arr: array[18] },
    //     { arr: array[19] },
    //     { arr: array[20] },
    //     { arr: array[21] },
    //   ],
    // },
    // {
    //   name: "Create Retailer",
    //   id: "create",
    //   url: array[18] == "1" ? "/create" : null,
    //   roles: [],
    //   component: <Retailer />,
    //   Icon: RetailerIcon,
    // },
    // {
    //   name: "Edit Retailer",
    //   id: "edit",
    //   url: array[19] == "1" ? "/edit" : null,
    //   roles: [],
    //   component: <Retailer />,
    //   Icon: RetailerIcon,
    // },
    // {
    //   name: "Suspend Retailer",
    //   id: "delete",
    //   url: array[20] == "1" ? "/delete" : null,
    //   roles: [],
    //   component: <Retailer />,
    //   Icon: RetailerIcon,
    // },
    // {
    //   name: "Authorize Retailer",
    //   id: "auth",
    //   url: array[21] == "1" ? "/auth" : null,
    //   roles: [],
    //   component: <Retailer />,
    //   Icon: RetailerIcon,
    // },
    // Transaction Controller
    {
      name: "Purchase Credits",
      id: "buysms",
      url: array[22] == "1" ? "/buysms" : null,
      component: <BuySMS />,
      arr: array[22],
      roles: [],
      Icon: BuySMSIcon,
    },
    {
      name: "Purchase Credits",
      id: "buysms",
      url: array[22] == "1" ? "/buysms" : null,
      roles: [],
      Icon: BuySMSIcon,
      menuShow: true,
      grandChild: [{ arr: array[23] }],
    },
    {
      name: "Buy SMS Create",
      id: "create",
      url: array[23] == "1" ? "/create" : null,
      roles: [],
      component: <BuySMS />,
      Icon: BuySMSIcon,
    },
    // {
    //   name: "Top-up SMS",
    //   id: "sellsms",
    //   url: array[24] == "1" ? "/sellsms" : null,
    //   component: <SellSMS />,
    //   arr: array[24],
    //   roles: [],
    //   Icon: SellSMSIcon,
    // },
    // {
    //   name: "Top-up SMS",
    //   id: "sellsms",
    //   url: array[24] == "1" ? "/sellsms" : null,
    //   roles: [],
    //   Icon: SellSMSIcon,
    //   menuShow: true,
    //   grandChild: [{ arr: array[25] }],
    // },
    // {
    //   name: "Top-up SMS Create",
    //   id: "create",
    //   url: array[25] == "1" ? "/create" : null,
    //   roles: [],
    //   component: <SellSMS />,
    //   Icon: SellSMSIcon,
    // },
    // {
    //   name: "API Document",
    //   id: "api-document",
    //   url: array[24] == "1" ? "api-document" : null,
    //   component: <APIDoc />,
    //   arr: array[24],
    //   roles: [],
    //   Icon: APIDocIcon,
    // },
    {
      name: "SMS Api Document",
      id: "sms-api-document",
      url: array[24] == "1" ? "sms-api-document" : null,
      component: <APIDoc />,
      arr: array[24],
      roles: [],
      Icon: APIDocIcon,
    },
    {
      name: "RCS Api Document",
      id: "rcs-api-document",
      url: array[27] == "1" ? "rcs-api-document" : null,
      component: <APIDoc />,
      arr: array[27],
      roles: [],
      Icon: APIDocIcon,
    },
    {
      name: "Customer SMS Logs",
      id: "smstransaction",
      url: array[25] == "1" ? "/smstransaction" : null,
      component: <SmsHistory />,
      arr: array[25],
      roles: [],
      Icon: SmsHistoryIcon,
    },
    {
      name: "Customer RCS Logs",
      id: "rcstransaction",
      url: array[26] == "1" ? "/rcstransaction" : null,
      component: <RcsHistory />,
      arr: array[26],
      roles: [],
      Icon: SmsHistoryIcon,
    },
    {
      name: "Menu Management",
      id: "menuManagement",
      url: array[28] == "1" ? "/menuManagement" : null,
      component: <MenuManagement />,
      arr: array[28],
      roles: [],
      Icon: MenuManagementIcon,
    },
    {
      name: "System SMS Logs",
      id: "smsmaster",
      url: array[30] == "1" ? "/smsmaster" : null,
      component: <SMSMaster />,
      arr: array[30],
      roles: [],
      Icon: SMSMasterIcon,
    },
    // Role Controller
    {
      name: "Role Master",
      id: "roleMaster",
      url: array[31] == "1" ? "/roleMaster" : null,
      component: <RoleMaster />,
      arr: array[31],
      roles: [],
      Icon: RoleMasterIcon,
    },
    {
      name: "Role Master",
      id: "roleMaster",
      url: array[31] == "1" ? "/roleMaster" : null,
      roles: [],
      Icon: RoleMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[32] },
        { arr: array[33] },
        { arr: array[34] },
        { arr: array[35] },
      ],
    },
    {
      name: "Create Role",
      id: "create",
      url: array[32] == "1" ? "/create" : null,
      roles: [],
      component: <RoleMaster />,
      Icon: RoleMasterIcon,
    },
    {
      name: "Edit Role",
      id: "edit",
      url: array[33] == "1" ? "/edit" : null,
      roles: [],
      component: <RoleMaster />,
      Icon: RoleMasterIcon,
    },
    {
      name: "Suspend Role",
      id: "delete",
      url: array[34] == "1" ? "/delete" : null,
      roles: [],
      component: <RoleMaster />,
      Icon: RoleMasterIcon,
    },
    {
      name: "Authorize Role",
      id: "auth",
      url: array[35] == "1" ? "/auth" : null,
      roles: [],
      component: <RoleMaster />,
      Icon: RoleMasterIcon,
    },
    // Top Up Request
    // {
    //   name: "Top Up Request",
    //   id: "topUpRequest",
    //   url: array[36] == "1" ? "/topUpRequest" : null,
    //   component: <TopUpReq />,
    //   arr: array[36],
    //   roles: [],
    //   Icon: TopUpReqIcon,
    // },
    // {
    //   name: "Top Up Request",
    //   id: "topUpRequest",
    //   url: array[36] == "1" ? "/topUpRequest" : null,
    //   roles: [],
    //   Icon: TopUpReqIcon,
    //   menuShow: true,
    //   grandChild: [
    //     { arr: array[37] },
    //     { arr: array[38] },
    //     { arr: array[39] },
    //     { arr: array[40] },
    //   ],
    // },
    {
      name: "Create Role",
      id: "create",
      url: array[37] == "1" ? "/create" : null,
      roles: [],
      component: <TopUpReq />,
      Icon: TopUpReqIcon,
    },
    {
      name: "Edit Role",
      id: "edit",
      url: array[38] == "1" ? "/edit" : null,
      roles: [],
      component: <TopUpReq />,
      Icon: TopUpReqIcon,
    },
    {
      name: "Suspend Role",
      id: "delete",
      url: array[39] == "1" ? "/delete" : null,
      roles: [],
      component: <TopUpReq />,
      Icon: TopUpReqIcon,
    },
    {
      name: "Authorize Role",
      id: "auth",
      url: array[40] == "1" ? "/auth" : null,
      roles: [],
      component: <TopUpReq />,
      Icon: TopUpReqIcon,
    },
    {
      name: "Vendor History",
      id: "vendortxnhistory",
      url: array[41] == "1" ? "/vendortxnhistory" : null,
      component: <VendorTxnHistory />,
      arr: array[41],
      roles: [],
      Icon: VendorHistoryIcon,
    },

    {
      name: "Bulk Message",
      id: "bulkMessage",
      url: array[42] == "1" ? "/bulkMessage" : null,
      component: <BulkReport />,
      arr: array[42],
      roles: [],
      Icon: BulkSmsIcon,
    },
    {
      name: "Bulk Message",
      id: "bulkMessage",
      url: array[42] == "1" ? "/bulkMessage" : null,
      roles: [],
      Icon: UsersIcon,
      menuShow: true,
      grandChild: [{ arr: array[43] }],
    },

    //Recharge
    {
      name: "Recharge",
      id: "transactionReport",
      url: array[60] == "1" ? "/transactionReport" : null,
      component: <TransactionReport />,
      arr: array[60],
      roles: [],
      Icon: TxnReport,
    },
    // //Recharge
    // {
    //   name: "Recharge",
    //   id: "recharge",
    //   url: array[60] == "1" ? "/recharge" : null,
    //   component: <Recharge />,
    //   arr: array[60],
    //   roles: [],
    //   Icon: RechargeIcon,
    // },

    //SMS/RCS Wallet
    {
      name: "Top-Up SMS/RCS",
      id: "walletActivity",
      url: array[44] == "1" ? "/walletActivity" : null,
      component: <MainWalletActivity />,
      arr: array[44],
      roles: [],
      Icon: WalletBlueIcon,
    },
    {
      name: "Top-Up SMS/RCS",
      id: "walletActivity",
      url: array[44] == "1" ? "/walletActivity" : null,
      roles: [],
      Icon: WalletBlueIcon,
      menuShow: true,
      grandChild: [
        { arr: array[45] },
        { arr: array[46] },
        { arr: array[47] },
        { arr: array[48] },
        { arr: array[85] }, // ✅ Top-Up-SMS (updated index)
        { arr: array[86] }, // ✅ Top-Up-RCS (updated index)
      ],
    },
    // Main Wallet
    {
      name: "Main Wallet",
      id: "topUpMainWallet",
      url: array[49] == "1" ? "/topUpMainWallet" : null,
      component: <TopUpMainWalletReq />,
      arr: array[49],
      roles: [],
      Icon: WalletBlueIcon,
    },
    {
      name: "Main Wallet",
      id: "topUpMainWallet",
      url: array[49] == "1" ? "/topUpMainWallet" : null,
      roles: [],
      Icon: WalletBlueIcon,
      menuShow: true,
      grandChild: [
        { arr: array[50] }, // Create
        { arr: array[57] }, // Modify (custom index)
        { arr: array[53] }, // Delete
        { arr: array[51] }, // Authorize
        { arr: array[52] }, // Audit Trail
        { arr: array[58] }, // DLT
        { arr: array[59] }, // Checker
      ],
    },
    //Ledger Page
    {
      name: "Ledger",
      id: "ledger",
      url: array[67] == "1" ? "/ledger" : null,
      component: <Ledger />,
      arr: array[67],
      roles: [],
      Icon: LedgerIcon,
    },
    //RCS Standalone
    {
      name: "RCS Standalone Msg",
      id: "rcsstandalonemsg",
      url: array[68] == "1" ? "/rcsstandalonemsg" : null,
      component: <RCSStandalone />,
      arr: array[68],
      roles: [],
      Icon: RCSStandAloneIcon,
    },
    //RCS Plain Text
    {
      name: "RCS Plain Text",
      id: "rcsplaintext",
      url: array[69] == "1" ? "/rcsplaintext" : null,
      component: <RCSSPainText />,
      arr: array[69],
      roles: [],
      Icon: RCSPlainTextIcon,
    },
    //RCS Carousel
    {
      name: "RCS Carousel",
      id: "rcscarousel",
      url: array[70] == "1" ? "/rcscarousel" : null,
      component: <RCSCarousel />,
      arr: array[70],
      roles: [],
      Icon: RCSCarouselIcon,
    },
    //RCS Templates
    {
      name: "RCS Templates",
      id: "rcstemplates",
      url: (array[68] == "1") ? "/rcstemplates" : null,
      component: <RcsTemplate />,
      arr: (array[68] == "1") ? 1 : 0,
      roles: [],
      Icon: RCSStandAloneIcon,
    },

    //WhatsApp Template
    /*
    {
      name: "WhatsApp Template",
      id: "whatsapptemplate",
      url: (sessionStorage.getItem("userRole") === "CUST" && array[83] == "1") ? "/whatsapptemplate" : null,
      component: <WhatsappTemplate />,
      arr: (sessionStorage.getItem("userRole") === "CUST" && array[83] == "1") ? 1 : 0,
      roles: [],
      Icon: BulkSmsIcon,
    },
    */

    //Setting
    {
      name: "Settings",
      id: "settings",
      url: array[29] == "1" ? "/settings" : null,
      component: <Settings />,
      arr: array[29],
      roles: [],
      Icon: SettingsIcon,
    },
  ];
  return {
    PROTECTED_ROUTES,
  };
};
export default Routes;
//Last Used 54-86
// Top-Up-SMS - Index 85
// Top-Up-RCS - Index 86
// AI Dashboard - Index 87
// RCS Templates - Index 88
// In MasterTable.jsx, RCS Agent Details have array number 86
